import { render, staticRenderFns } from "./overseas-basecostsetting.vue?vue&type=template&id=1cfb97bc"
import script from "./overseas-basecostsetting.vue?vue&type=script&lang=ts"
export * from "./overseas-basecostsetting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports